module.exports = __webpack_public_path__ + "img/9788981339524.81281f93.jpg";